import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { useSEO } from "../hooks/useSEO";
import { site } from "../data/site";

export default function Privacy() {
  useSEO({
    title: "Politique de confidentialité | Embèk Group",
    description: "Politique de confidentialité du site Embèk Group : traitement des données personnelles, formulaires de contact et de devis, vos droits.",
  });

  return (
    <>
      <PageHeader eyebrow="Confidentialité" title="Politique de confidentialité" />
      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 space-y-6 text-coal-muted font-light leading-relaxed text-[15px]">
          <Reveal>
            <p>Chez {site.name}, nous accordons une grande importance à la protection de vos données personnelles. Cette politique explique quelles informations nous collectons et comment nous les utilisons.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-forest pt-4">1. Responsable du traitement</h2>
            <p className="mt-2">Le responsable du traitement est {site.name} — {site.address}. Contact : {site.email} — {site.phone}.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-forest pt-4">2. Données collectées</h2>
            <p className="mt-2">Via nos formulaires (demande de devis, contact, prise de rendez-vous en ligne) : nom, prénom, numéro de téléphone, adresse e-mail, adresse ou commune, description de votre projet et, si vous le souhaitez, les photos que vous joignez à votre demande.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-forest pt-4">3. Finalité et durée de conservation</h2>
            <p className="mt-2">Vos données sont utilisées uniquement pour répondre à votre demande, établir un devis et assurer le suivi commercial associé. Elles sont conservées le temps nécessaire au traitement de votre demande, puis archivées ou supprimées conformément à la réglementation en vigueur.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-forest pt-4">4. Vos droits</h2>
            <p className="mt-2">Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de vos données. Pour l'exercer, écrivez-nous à {site.email}.</p>
          </Reveal>
          <Reveal>
            <h2 className="font-serif text-2xl text-forest pt-4">5. Cookies et mesure d'audience</h2>
            <p className="mt-2">Ce site n'utilise pas de cookie publicitaire. Seules des mesures d'audience strictement anonymes peuvent être mises en œuvre. La carte interactive est fournie par Google Maps, dont nous vous invitons à consulter la politique de confidentialité.</p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
